import type { Pagination as PaginationModel } from '../lib/types'

export function Pagination({
  pagination,
  onPage,
}: {
  pagination: PaginationModel
  onPage: (page: number) => void
}) {
  if (pagination.totalPages <= 1) return null
  return (
    <nav aria-label="Paginazione" className="pagination">
      <button
        disabled={pagination.page <= 1}
        onClick={() => onPage(pagination.page - 1)}
        type="button"
      >
        ← Precedente
      </button>
      <span>
        Pagina {pagination.page} / {pagination.totalPages}
      </span>
      <button
        disabled={pagination.page >= pagination.totalPages}
        onClick={() => onPage(pagination.page + 1)}
        type="button"
      >
        Successiva →
      </button>
    </nav>
  )
}
